import { OrderType, useSearchExamCentersQuery } from '@exam-center/graphql';
import { useNavigate } from '@exam-center/router';
import { DataGrid, type GridEventListener, type GridRowParams } from '@shared/components';
import { useMemo } from 'react';

import { ExamCenterListNoRowsOverlay } from '../exam-center-list-no-rows-overlay';

import { columns, type ExamCenterListItem } from './columns';

export default function ExamCenterList() {
  const navigate = useNavigate();

  const { data: examCentersData, loading: isLoading } = useSearchExamCentersQuery({
    variables: {
      searchExamCentersInput: {
        order: {
          field: 'examCenterId',
          type: OrderType.Asc,
        },
        filter: undefined,
        paging: {
          currentPage: 0,
          pageSize: 100, // NOTE: We don't have pagination for exam center list since in production, we only have 3 exam centers
        },
      },
    },
  });

  const examCenters = useMemo(() => {
    return examCentersData?.ecSearchExamCenters.examCenters ?? [];
  }, [examCentersData]);

  const handleRowClick: GridEventListener<'rowClick'> = (
    params: GridRowParams<ExamCenterListItem>,
  ) => {
    navigate('/admin/exam-centers/:examCenterCode/details', {
      params: {
        examCenterCode: params.row.code,
      },
    });
  };

  return (
    <DataGrid
      columns={columns}
      rows={examCenters}
      loading={isLoading}
      onRowClick={handleRowClick}
      rowHeight={48}
      hideFooter
      disableColumnMenu
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
      slots={{
        noRowsOverlay: ExamCenterListNoRowsOverlay,
      }}
    />
  );
}
